export default __webpack_public_path__ + "489e194c7c04fe49be12c103679749ab.svg";